<template>
  <div class="grid_row">
    <v-slide-x-reverse-transition>
      <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
      <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
    </v-slide-x-reverse-transition>
    <v-form ref="create_cn" @submit.prevent="create_cn">
      <v-card>
        <div class="pa-4">
          <div class="grid_reture_edit_text mb-2">
            <div>เลขที่ใบส่งคืนสินค้า</div>
            <div class="ml-2" v-if="header_list.return_edit_text">วิธีการแก้ไข</div>
          </div>
          <div class="grid_reture_edit_text">
            <div>
              <v-autocomplete color="#86bc3a" @input="get_detail(doc_no)" :items="supplier_list" item-text="doc_no" item-value="doc_no" prepend-inner-icon="mdi-file-compare" label="เลขที่ใบส่งคืนสินค้า" v-model="doc_no" hide-details="auto" outlined></v-autocomplete>
            </div>
            <div class="ml-4 d-flex justify-center flex-column">{{ header_list.return_edit_text }}</div>
          </div>
          <div class="grid_half">
            <div class="grid_list">
              <div class="mt-4 ml-1 mr-1">
                <div>เลขที่ใบส่งลดหนี้ (CN)</div>
                <div class="pa-2 mt-3" v-if="header_list != ''">{{ header_list.doc_from_supplier }}</div>
                <div class="pa-2 mt-3" v-else>-</div>
<!--                <v-text-field color="#86bc3a" label="เลขที่ใบส่งลดหนี้ (CN)" :rules="[v => !!v || 'กรุณากรอกเลขที่ใบส่งลดหนี้']" prepend-inner-icon="mdi-account-outline" hide-details="auto" v-model="header_list.doc_from_supplier" outlined></v-text-field>-->
              </div>
              <div class="mt-4 ml-md-1 ml-lg-1 ml-xl-1 mr-1">
                <div>วันที่ใบส่งลดหนี้</div>
                <div class="ml-1 mt-2">
                  <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field color="#86bc3a" v-model="date" label="วันที่(วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker color="#86bc3a" @change="diffDate_TH(dateEN)" v-model="dateEN" :max="start_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="selectDate()">
                        ตกลง
                      </v-btn>
                      <v-btn text color="primary" @click="menu_date = false">
                        ยกเลิก
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid_full pa-4">
          <div class="mb-1">สินค้า</div>
          <div style="display: flex; !important;">
            <v-autocomplete color="#86bc3a" :items="product_list" @input="add_product(pro_id)" item-text="product_name" item-value="product_id" v-model="pro_id" prepend-inner-icon="mdi-flask-plus-outline" label="สินค้า" hide-details="auto" outlined/>
          </div>
        </div>
        <div class="pa-2">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="Pr_List" :items="data_list" key="index" hide-default-footer :search="search" mobile-breakpoint="0">
            <template v-slot:item="dataDetail" >
              <tr>
                <td>{{ dataDetail.index + 1 }}</td>
                <td>{{ dataDetail.item.product_code }}</td>
                <td><v-text-field color="#86bc3a" label="ล็อต" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกล็อต']" v-model="dataDetail.item.lot_no" outlined></v-text-field></td>
                <td>{{ dataDetail.item.product_name }}</td>
                <td>
                  <v-select color="#86bc3a" :items="dataDetail.item.units" label="หน่วยนับ" :rules="[v => !!v || 'กรุณากรอกหน่วยนับ']" item-text="unit_name"  item-value="unit_id" hide-details="auto" v-model="dataDetail.item.unit_id" outlined/>
                </td>
                <td>
                  <date-picker clearable class="input_style" :disabled-date="notBeforeToday" value-type="format" :formatter="format" v-model="dataDetail.item.date_expired" :placeholder="dataDetail.item.date_expired"/>
                </td>
                <td>
                  <v-text-field type="number" min="0" color="#86bc3a" label="จำนวน" hide-details="auto" @keypress="isOnlyNumber($event)" :rules="[v => !!v || 'กรุณากรอกจำนวน']" v-model="dataDetail.item.qty" outlined></v-text-field>
                </td>
                <td>
                  <v-text-field type="number" min="0" color="#86bc3a" label="ราคาต่อหน่วย" hide-details="auto" @keypress="isCurrency($event, dataDetail.item.price)" :rules="[v => !!v || 'กรุณากรอกราคาต่อหน่วย']" v-model="dataDetail.item.price" outlined></v-text-field>
                </td>
                <td>{{ format_price(dataDetail.item.total = dataDetail.item.qty * dataDetail.item.price) }}</td>
                <td>
                  <div class="v-input__slot">
                    <v-checkbox color="#86bc3a" v-model="dataDetail.item.cn_return" v-if="dataDetail.item.old_cn_return == false"/>
                    <div v-if="dataDetail.item.old_cn_return == true">-</div>
                  </div>
                </td>
                <td class="pa-3">
                  <div class="text-center" v-if="dataDetail.item.id !== null">-</div>
                  <v-btn v-else small height="42" @click="getDelete(dataDetail.item.loop_id)" class="grad-danger-bg white--text mb-1">
                    <v-icon>mdi-delete-empty-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <div class="pa-6 text-right">
          <v-btn x-large type="submit" class="grad-success-bg white--text" style="font-size: 18px">บันทึกข้อมูล</v-btn>
        </div>
      </v-card>
    </v-form>
    <v-overlay :value="overlay" class="z_index">
      <div class="text-center">
        <v-progress-circular
            indeterminate
            size="70"
            width="7"
            color="#86bc3a"
        ></v-progress-circular>
        <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {formatPrice, minDate, onlyForCurrency, onlyForNumber} from "@/js/handler";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  components: {
    DatePicker
  },
  name: "StorageCN",
  data() {
    return {
      search: null,
      date: '',
      dateEN: '',
      overlay: false,
      menu_date: false,
      start_date: this.min_date(),
      alert_success: false,
      alert_danger: false,
      format: {
        stringify: (date) => {
          const date_moment = moment(date).format('DD-MM-YYYY')
          const diff = date_moment.split('-')
          const day = diff[0]
          const month = diff[1]
          const year = parseInt(diff[2])+ 543
          return day+'-'+month+'-'+year
        },
      },
      doc_no: null,
      pro_id: null,
      Pr_List: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '95px',
        },
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '130px',
        },
        {
          text: 'ล็อต',
          value: 'product_lot',
          fixed: true,
          width: '180px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'หน่วยนับ',
          value: 'product_unit',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันที่หมดอายุ',
          value: 'product_date',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'count',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price_unit',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          fixed: true,
          width: '180px',
        },
        {
          text: 'สินค้ารอคืน',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'ลบ',
          value: '',
          sortable: false,
          fixed: true,
          width: '50px',
        },
      ],
      supplier_list: [],
      header_list: [],
      product_list: [],
      data_list: [],
      unit_list: [],
      loop_id: 0,
    }
  },
  methods: {
    cache_page() {
      window.addEventListener('beforeunload', function (event) {
        event.preventDefault();
        event.returnValue = '';
      })
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    date_table(value) {
      if (value !== null) {
        const diff = value.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0])+ 543
        return day+'-'+month+'-'+year
      }
      else {
        let result = this.min_date()
        const diff = result.split('-')
        const day = diff[2]
        const month = diff[1]
        const year = parseInt(diff[0])+ 543
        return day+'-'+month+'-'+year
      }
    },
    diffDate_TH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'-'+month+'-'+year
      return this.date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    min_date: function () {
      return minDate()
    },
    get_supplier() {
      HTTP.post('imports/cn/getcn')
          .then((res) => {
            if (res.data.success === true) {
              this.supplier_list = res.data.object
            }
          })
    },
    async get_detail(doc_no) {
      this.product_list = []
      this.data_list = []
      await HTTP.post('imports/cn/getcndetail', {
        doc_no: doc_no
      }).then((res) => {
        if (res.data.success === true) {
          this.header_list = res.data.object.head
          if (res.data.object.head.return_date !== null) {
            this.date = res.data.object.head.return_date
            this.dateEN = res.data.object.head.return_date
            this.diffDate_TH(this.date)
          }
          else {
            this.date = ''
          }
          this.product_list = res.data.object.products
          if (res.data.object.lists.length > 0) {
            res.data.object.lists.forEach((data) => {
              const id = this.loop_id +=1;
              this.data_list.push({
                loop_id: id,
                id: data.id,
                lot_no: data.lot_no,
                product_id: data.product_id,
                product_code: data.product_code,
                product_name: data.product_name,
                qty: data.qty,
                reason: data.reason,
                return_product_id: data.return_product_id,
                unit_id: data.unit_id,
                units: data.units,
                date_expired: this.date_table(data.date_expired),
                price: null,
                total: 0,
                warehouse_return_id: data.warehouse_return_id,
                cn_return: false,
                old_cn_return: true,
              })
            })
          }
        }
      })
    },
    async add_product(pro_id) {
      await HTTP.post('/imports/cn/units', {
        product_id: pro_id
      }).then((res) => {
        if (res.data.success === true) {
          this.alert_success = true;
          this.unit_list = res.data.object
        }
      })
      let value = this.product_list.filter((res) => {
        return res.product_id === pro_id
      });
      value.forEach((data) => {
        const id = this.loop_id +=1;
        this.data_list.push({
          loop_id: id,
          id: null,
          lot_no: null,
          product_id: data.product_id,
          product_code: data.product_code,
          product_name: data.product_name,
          qty: null,
          reason: null,
          return_product_id: null,
          unit_id: data.unit_id,
          units: this.unit_list,
          date_expired: this.date_table(this.min_date()),
          price: null,
          total: 0,
          warehouse_return_id: null,
          cn_return: false,
          old_cn_return: false,
        })
      })
      await this.$nextTick(() => {
        this.pro_id = null;
        setTimeout(() => this.alert_success = false, 3000);
      })
    },
    create_cn() {
      if (this.$refs.create_cn.validate()) {
        if (this.data_list.length > 0) {
          Swal.fire({
            text: 'ต้องการบันทึกข้อมูลหรือไม่ ?',
            icon: 'warning',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then((res) => {
            if (res.isConfirmed === true) {
              this.overlay = true
              HTTP.post('/imports/cn/create', {
                return_edit_text: this.header_list.return_edit_text,
                user_id: this.$store.state.userDetail.id,
                user_name: this.$store.state.userDetail.name,
                id: this.header_list.id,
                tf_no: this.header_list.tf_no,
                supplier_id: this.header_list.supplier_id,
                doc_no: this.doc_no,
                doc_from_supplier: this.header_list.doc_from_supplier,
                cn_date: this.dateEN,
                note: this.header_list.note,
                data_list: this.data_list,
              }).then((res) => {
                if (res.data.success === true){
                  this.overlay = false
                  Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
                      .then(() => {
                        this.$router.push('/stock/storage/addproducttostock');
                      });
                }
              })
            }
          })
        }
        else {
          Swal.fire({
            text: 'กรุณาตรวจสอบข้อมูล !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          })
        }
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'เนื่องจาก ไม่มีข้อมูลหรือกรอกข้อมูลไม่ครบ !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
    getDelete(loop_id) {
      Swal.fire({
        text: 'ต้องการลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.alert_danger = true;
          setTimeout(() => this.alert_danger = false, 3000);
          this.data_list = this.data_list.filter(detail => detail.loop_id !== loop_id)
        }
      })
    }
  },
  mounted() {
    this.get_supplier()
  },
  created() {
    this.cache_page()
  },
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_row {
  display: grid;
  grid-template-columns: 100%;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}
.text_return {
  margin-top: 27px;
}
.v-input__slot {
  align-items: center !important;
  justify-content: center !important;
  padding-top: 10px !important;
}
.input_style >>> input {
  border: #9e9e9e solid 1px !important;
  transition: 0.2s !important;
  font-size: 18px !important;
  color: black !important;
  padding: 27px !important;
  padding-left: 12px !important;
}
.input_style >>> input:hover {
  border-color: black !important;
}
.input_style >>> input:focus {
  border-color: #8cc63e !important;
}

.grid_reture_edit_text{
  display: grid;
  grid-template-columns: 25% 75%;
}


.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td{
  height: 90px;
}


@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 500px) {
  .text_return {
    margin-top: 15px;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_reture_edit_text{
    grid-template-columns: 100%;
  }
}
</style>
